export const OTHER_SPORT_OPTIONS = [
  "Archery",
  "Baseball",
  "Basketball",
  "Bowling",
  "Cheerleading",
  "Cross Country",
  "Dance",
  "Diving",
  "Equestrian",
  "Field Hockey",
  "Fencing",
  "Football",
  "Gymnastics",
  "Ice Hockey",
  "Lacrosse",
  "Rowing / Crew",
  "Rugby",
  "Sailing",
  "Skiing",
  "Soccer",
  "Softball",
  "Squash",
  "Swimming",
  "Tennis",
  "Track and Field",
  "Volleyball",
  "Water Polo",
  "Wrestling",
] as const;
